export default "__VITE_ASSET__DPRHOONl__"